import { Item } from 'models/IItem';
import { FC, useContext } from 'react';
import type { SolveMode as SolveModeEnum } from 'state/addonForm';

import { AddonMainFormContext } from '../AddonMainForm.context';
import { ListField } from './ListField';

interface OwnProps {
  solveModes: readonly SolveModeEnum[];
  value?: SolveModeEnum;
  onChange: (newSolveMode: SolveModeEnum) => void;
}
export const SolveFor: FC<OwnProps> = ({ solveModes, value, onChange }) => {
  const { isLoading, isReadOnly } = useContext(AddonMainFormContext);

  return (
    <ListField
      id="solvingMode"
      disabled={isReadOnly}
      isLoading={isLoading}
      translationKey="solveFor"
      availableItems={solveModes.map((mode): Item<SolveModeEnum> => ({
        value: mode,
        label: mode.toString(),
      }))}
      value={value!}
      onValueChange={onChange}
    />
  );
};
